/*
  Personal cart offer box (snippets/cart-offer.liquid), WebTalent 2026-11.
  - The button adds 1 unit with the hidden property `_offer`; the Promise Packs cart function
    sets its price. The cart drawer then re-renders (the box disappears, the line shows up).
  - The box hides itself outside its start/end (day + hour, YYYYMMDDHHMM), in case the page came
    from a cache or stayed open past the end.
*/
(function () {
  if (window.__cartOfferBound) return;
  window.__cartOfferBound = true;

  // Now in the shop's time zone (Israel), as 202611040905.
  function now() {
    try {
      var parts = {};
      new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Asia/Jerusalem',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23',
      })
        .formatToParts(new Date())
        .forEach(function (part) {
          parts[part.type] = part.value;
        });
      return Number(parts.year + parts.month + parts.day + parts.hour + parts.minute);
    } catch (error) {
      return 0;
    }
  }

  if (!customElements.get('cart-offer')) {
    customElements.define(
      'cart-offer',
      class extends HTMLElement {
        connectedCallback() {
          var box = this;
          var start = Number(box.dataset.start);
          var end = Number(box.dataset.end);
          if (!start || !end) return;
          var check = function () {
            var at = now();
            if (at && (at < start || at >= end)) {
              box.hidden = true;
              clearInterval(box._timer);
            }
          };
          check();
          clearInterval(box._timer);
          if (!box.hidden) box._timer = setInterval(check, 60000);
        }
        disconnectedCallback() {
          clearInterval(this._timer);
        }
      }
    );
  }

  function cartAddUrl() {
    var url = (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add';
    return /\.js$/.test(url) ? url : url + '.js';
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-cart-offer-add]');
    if (!button || button.disabled) return;
    event.preventDefault();

    var box = button.closest('cart-offer');
    var error = box && box.querySelector('[data-cart-offer-error]');
    if (error) error.hidden = true;
    if (box) box.classList.add('is-loading');
    button.disabled = true;

    fetch(cartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(button.dataset.variantId), quantity: 1, properties: { _offer: '1' } }],
      }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart add failed: ' + response.status);
        return response.json();
      })
      .then(function () {
        if (button.closest('[data-cart-drawer]')) {
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        } else {
          window.location.reload();
        }
      })
      .catch(function (failure) {
        console.error('[cart-offer]', failure);
        button.disabled = false;
        if (box) box.classList.remove('is-loading');
        if (error) error.hidden = false;
      });
  });
})();
